import { BreakpointObserver, MediaMatcher } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { CoreService } from 'src/app/services/core.service';
import { AppSettings } from 'src/app/app.config';
import { filter, map, tap } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { navItems } from './vertical/sidebar/sidebar-data';
import { NavService } from '../../services/nav.service';
import { AppNavItemComponent } from './vertical/sidebar/nav-item/nav-item.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './vertical/sidebar/sidebar.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TablerIconsModule } from 'angular-tabler-icons';
import { HeaderComponent } from './vertical/header/header.component';
import { AppHorizontalHeaderComponent } from './horizontal/header/header.component';
import { AppHorizontalSidebarComponent } from './horizontal/sidebar/sidebar.component';
import { AppBreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { AppearanceOptions, CustomizerComponent } from './shared/customizer/customizer.component';
import { Roles } from './shared/Enums';
import { UserService } from 'src/app/services/user.service';
import { ModalCreateClientComponent } from 'src/app/components/modal-create-client/modal-create-client.component';
import { User } from 'src/app/models/user.model';
import { ServicesService } from 'src/app/services/services.service';
import { Service } from 'src/app/models/service.model';
import { SidenavService } from 'src/app/services/sidenav.service';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';
const BELOWMONITOR = 'screen and (max-width: 1023px)';

// for mobile app sidebar
interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

@Component({
  selector: 'app-full',
  standalone: true,
  imports: [
    RouterModule,
    AppNavItemComponent,
    MaterialModule,
    CommonModule,
    SidebarComponent,
    NgScrollbarModule,
    TablerIconsModule,
    HeaderComponent,
    AppHorizontalHeaderComponent,
    AppHorizontalSidebarComponent,
    AppBreadcrumbComponent,
    CustomizerComponent,
    ModalCreateClientComponent
  ],
  templateUrl: './full.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None,
})
export class FullComponent implements OnInit {

  navItems = navItems;
  @ViewChild('customizerRight', { static: true }) customizerRight!: MatSidenav;

  @ViewChild('leftsidenav')
  public sidenav: MatSidenav;
  resView = false;
  @ViewChild('content', { static: true }) content!: MatSidenavContent;
  //get options from service
  options = this.settings.getOptions();
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  private htmlElement!: HTMLHtmlElement;
  userRole: string = ""
  user: User
  services: Service[]
  hasProFeatures: boolean = false

  get isOver(): boolean {
    return this.isMobileScreen;
  }

  get isTablet(): boolean {
    return this.resView;
  }

  // for mobile app sidebar
  apps: apps[] = [
    {
      id: 1,
      img: '/assets/images/svgs/icon-dd-chat.svg',
      title: 'Chat Application',
      subtitle: 'Messages & Emails',
      link: '/apps/chat',
    },
    {
      id: 2,
      img: '/assets/images/svgs/icon-dd-cart.svg',
      title: 'eCommerce App',
      subtitle: 'Buy a Product',
      link: '/apps/email/inbox',
    },
    {
      id: 3,
      img: '/assets/images/svgs/icon-dd-invoice.svg',
      title: 'Invoice App',
      subtitle: 'Get latest invoice',
      link: '/apps/invoice',
    },
    {
      id: 4,
      img: '/assets/images/svgs/icon-dd-date.svg',
      title: 'Calendar App',
      subtitle: 'Get Dates',
      link: '/apps/calendar',
    },
    {
      id: 5,
      img: '/assets/images/svgs/icon-dd-mobile.svg',
      title: 'Contact Application',
      subtitle: '2 Unsaved Contacts',
      link: '/apps/contacts',
    },
    {
      id: 6,
      img: '/assets/images/svgs/icon-dd-lifebuoy.svg',
      title: 'Tickets App',
      subtitle: 'Create new ticket',
      link: '/apps/tickets',
    },
    {
      id: 7,
      img: '/assets/images/svgs/icon-dd-message-box.svg',
      title: 'Email App',
      subtitle: 'Get new emails',
      link: '/apps/email/inbox',
    },
    {
      id: 8,
      img: '/assets/images/svgs/icon-dd-application.svg',
      title: 'Courses',
      subtitle: 'Create new course',
      link: '/apps/courses',
    },
  ];

  quicklinks: quicklinks[] = [
    {
      id: 1,
      title: 'Pricing Page',
      link: '/theme-pages/pricing',
    },
    {
      id: 2,
      title: 'Authentication Design',
      link: '/authentication/side-login',
    },
    {
      id: 3,
      title: 'Register Now',
      link: '/authentication/side-register',
    },
    {
      id: 4,
      title: '404 Error Page',
      link: '/authentication/error',
    },
    {
      id: 5,
      title: 'Notes App',
      link: '/apps/notes',
    },
    {
      id: 6,
      title: 'Employee App',
      link: '/apps/employee',
    },
    {
      id: 7,
      title: 'Todo Application',
      link: '/apps/todo',
    },
    {
      id: 8,
      title: 'Treeview',
      link: '/theme-pages/treeview',
    },
  ];

  constructor(
    private settings: CoreService,
    private mediaMatcher: MediaMatcher,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private navService: NavService,
    private userService: UserService,
    private servicesService: ServicesService,
    public sidenavService: SidenavService
  ) {
    this.user = this.userService.user;

    this.checkServices()

    this.htmlElement = document.querySelector('html')!;
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW, BELOWMONITOR])
      .subscribe((state) => {
        // SidenavOpened must be reset true when layout changes
        this.options.sidenavOpened = true;
        this.isMobileScreen = state.breakpoints[MOBILE_VIEW];
        if (this.options.sidenavCollapsed == false) {
          this.options.sidenavCollapsed = state.breakpoints[TABLET_VIEW];
        }
        this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
        this.resView = state.breakpoints[BELOWMONITOR];
      });

    // Priorizar datos de la base de datos sobre localStorage
    if (this.user.appearance) {
      const dbOptions: AppearanceOptions = {
        activeTheme: this.user.appearance?.activeTheme ?? 'blue_theme',
        boxed: this.user.appearance?.boxed ?? true,
        cardBorder: this.user.appearance?.cardBorder ?? false,
        dir: (this.user.appearance?.dir as 'ltr' | 'rtl') ?? 'ltr',
        horizontal: this.user.appearance?.horizontal ?? false,
        language: this.user.appearance?.language ?? 'en-us',
        navPos: (this.user.appearance?.navPos as 'side' | 'top') ?? 'side',
        sidenavCollapsed: this.user.appearance?.sidenavCollapsed ?? true,
        sidenavOpened: this.user.appearance?.sidenavOpened ?? false,
        theme: this.user.appearance?.theme ?? 'light',
      };

      this.settings.setOptions(dbOptions);
      this.options = dbOptions;

      // Actualizar localStorage con los datos de la BD
      localStorage.setItem('userAppearance', JSON.stringify(dbOptions));
    } else {
      // Fallback a localStorage solo si no hay datos en BD
      const savedAppearance = localStorage.getItem('userAppearance');
      if (savedAppearance) {
        this.settings.setOptions(JSON.parse(savedAppearance));
      }
    }

    // Initialize project theme with options
    this.receiveOptions(this.options);

    // This is for scroll to top
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((e) => {
        this.content.scrollTo({ top: 0 });
      });

    this.settings.notify.subscribe((options) => {
      this.receiveOptions(this.settings.getOptions());
    });
  }

  ngOnInit(): void {
    this.userRole = this.userService.user.role;

    // Configurar navItems después de cargar los servicios
    this.setupNavItems();

    if (window.location.pathname === '/') {
      this.router.navigate(['/home']);
    }
  }

  setupNavItems(): void {
    if (this.userRole === Roles.ROLE_DISTRIBUTOR) {
      this.navItems = [
        {
          displayName: 'HOME',
          iconName: 'home',
          route: '/home',
        },
        {
          displayName: 'ORDER.MANUFACTURING.TITLE',
          iconName: 'list',
          route: '/manufacturing',
        },
        {
          displayName: 'CLIENTS',
          iconName: 'users',
          route: '/clients',
        },
        {
          displayName: 'FILLABLE_PDF',
          iconName: 'file-type-pdf',
          route: '/fillable-pdfs',
        },
        {
          displayName: 'ANALYTICS',
          iconName: 'chart-bar',
          route: '/analytics',
        },
        {
          displayName: 'CUSTOM_FORMS',
          iconName: 'forms',
          route: '/custom-forms',
        },
        {
          displayName: 'WEBHOOKS',
          iconName: 'webhook',
          route: '/webhooks',
        },
      ];
    }

    if (this.userRole === Roles.ROLE_CUSTOMER) {
      if (this.hasProFeatures && this.user.connectedStripeId) {
        // Customer con Pro Features y Stripe → con Products
        this.navItems = [
          { displayName: 'HOME', iconName: 'home', route: '/home' },
          { displayName: 'CLINICS', iconName: 'building', route: '/clinics' },
          { displayName: 'USERS', iconName: 'users', route: '/users' },
          { displayName: 'CUSTOM_FORMS', iconName: 'forms', route: '/custom-forms' },
          { displayName: 'TEMPLATES', iconName: 'template', route: '/prescription-templates' },
          { displayName: 'PRODUCTS1', iconName: 'package', route: '/products' },
        ];
      } else {
        // Customer normal → sin Products
        this.navItems = [
          { displayName: 'HOME', iconName: 'home', route: '/home' },
          { displayName: 'CLINICS', iconName: 'building', route: '/clinics' },
          { displayName: 'USERS', iconName: 'users', route: '/users' },
          { displayName: 'CUSTOM_FORMS', iconName: 'forms', route: '/custom-forms' },
          { displayName: 'TEMPLATES', iconName: 'template', route: '/prescription-templates' },
        ];
      }
    }

    if (this.userRole === Roles.ROLE_CLINIC) {
      this.navItems = [
        {
          displayName: 'HOME',
          iconName: 'home',
          route: '/home',
        },
      ];
    }

    if (this.userRole === Roles.ROLE_ADMIN) {
      this.navItems = [
        {
          displayName: 'Dashboard',
          iconName: 'home',
          route: '/dashboard',
        },
      ];
    }
  }

  ngAfterViewInit() {
    this.sidenavService.setSidenav(this.sidenav);
  }

  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
  }

  checkServices() {
    this.servicesService.getServices().subscribe((services) => {
      services.map(service => {
        if (service.name === "Pro features") {
          this.hasProFeatures = true
        }
      })
      // Reconfigurar navItems después de obtener los servicios
      this.setupNavItems();
    });
  }

  toggleCollapsed() {
    this.isContentWidthFixed = false;
    this.options.sidenavCollapsed = !this.options.sidenavCollapsed;
    this.resetCollapsedState();
  }

  resetCollapsedState(timer = 400) {
    setTimeout(() => this.settings.setOptions(this.options), timer);
  }

  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
    this.options.sidenavOpened = isOpened;
    this.settings.setOptions(this.options);
  }

  receiveOptions(options: AppSettings): void {
    this.options = options;
    this.toggleDarkTheme(options);
  }

  toggleDarkTheme(options: AppSettings) {
    if (options.theme === 'dark') {
      this.htmlElement.classList.add('dark-theme');
      this.htmlElement.classList.remove('light-theme');
    } else {
      this.htmlElement.classList.remove('dark-theme');
      this.htmlElement.classList.add('light-theme');
    }
  }
}
